module.exports = __webpack_public_path__ + "static/media/shuttle-van.7fb08ade.svg";